import { render, staticRenderFns } from "./ApolloTaskShell.vue?vue&type=template&id=74caa346&"
import script from "./ApolloTaskShell.vue?vue&type=script&lang=ts&"
export * from "./ApolloTaskShell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports